import { stegaClean } from 'next-sanity';
import type { HTMLAttributes, ReactNode } from 'react';
import { CustomLink } from '../../components/custom-link';
import { cn } from '../../lib/utils';
import { SanityImage } from '../../sanity/utils/components';
import type { SanityImageProps } from '../../sanity/utils/fragments';

// Extracted from mobile-menu.tsx for reuse
function GridItemImages({ images }: { images?: SanityImageProps[] | null }) {
  if (!images || images.length === 0) {
    // Keep the placeholder div from the original desktop implementation if no images are provided
    return null;
  }
  return (
    <div className="flex justify-end gap-1 pr-2">
      {images.map((image) => (
        <SanityImage
          key={image.asset?._ref}
          image={image}
          className="size-12 flex-shrink-0 object-contain sm:size-9" // Added rounded-full and object-cover
        />
      ))}
    </div>
  );
}

export function GridItem({
  children,
  className,
  href,
  bgColor,
  textColor,
  images,
  ...props
}: {
  children: ReactNode;
  href: string;
  bgColor?: string;
  textColor?: string;
  images?: SanityImageProps[] | null;
  className?: string;
} & Omit<HTMLAttributes<HTMLAnchorElement>, 'href'>) {
  return (
    <CustomLink
      href={href}
      className={cn(
        'group grid h-12 grid-flow-col items-center justify-between text-balance pl-4 uppercase hf:underline lg:h-[52px]',
        className
      )}
      style={{
        color: textColor ? stegaClean(textColor) : undefined,
        backgroundColor: bgColor ? stegaClean(bgColor) : undefined,
      }}
      {...props}
    >
      <span>{children}</span>
      <GridItemImages images={images} />
    </CustomLink>
  );
}
